/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">店舗管理者画面</div>
            <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <form class="form_checkSetting">

                    <div class="wd400">
                        <p v-if="this.viewtype== 'TOP'" class="checkSetting_text">TOPメニュー画面 {{this.buttonname}}</p>
                        <p v-else-if="this.viewtype== 'day1'" class="checkSetting_text">TOPボタンA メニュー画面 {{this.buttonname}}</p>
                        <p v-else-if="this.viewtype== 'day2'" class="checkSetting_text">TOPボタンD メニュー画面 {{this.buttonname}}</p>
                        <p v-else-if="this.viewtype== 'ImCheck'" class="checkSetting_text">TOPメニューボタンB メニュー画面 {{this.buttonname}}</p>
                    </div><br>

                    <div class="wd720">
                        <Message v-if="ApivalidationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                        <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />
                    </div>

                    <div v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" class="lavel_store right_comment">
                        <label>ページ設定</label>
                    </div>
                    <div  v-if="this.viewtype== 'day1' || this.viewtype== 'day2'" style="padding: 15px" id="pageSetting" name="pageSetting" >
                        <table class="checkSetting_tbl_unit">
                            <tbody>
                                <tr>
                                    <th class="wd70">ページ<br>No</th>
                                    <th class="wd140 tbl_tex_center">タイトル</th>
                                    <th class="wd70">表示</th>
                                    <th class="wd70">設定<br>項目数</th>
                                    <th class="wd70">編集</th>
                                </tr>
                                <tr v-for="dailyCheckSettingList in dailyCheckSettingLists" :key="dailyCheckSettingList.dailyCheckPageNo" class="checkSetting_text_height">
                                    <td class="text_white_space checkSetting_text_align">{{dailyCheckSettingList.dailyCheckPageNo}}</td>
                                    <td class="text_white_space">{{dailyCheckSettingList.dailyCheckPageName}}</td>
                                    <td class="checkSetting_text_align">{{dailyCheckSettingList.displayStr}}</td>
                                    <td class="checkSetting_text_align">{{dailyCheckSettingList.dailyCheckItemCount}}/50</td>
                                    <td class=" checkSetting_buttan_unit checkSetting_kanri_box checkSetting_text_align">
                                        <ul class="ul_tbl_buttan">
                                            <li>
                                                <router-link
                                                    @click.native="setDailyCheckSetting(dailyCheckSettingList.dailyCheckPageId, dailyCheckSettingList.dailyCheckPageNo)"
                                                    :to="{ name: 'manageCheckImplementationViewSettingPage' , params:{ page:dailyCheckSettingList.dailyCheckPageNo }}">
                                                    編集</router-link>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </form><br>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'

export default {
    name: 'CheckImplementationViewSetting',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            isLoading:false,
            isInitLoading:true,
            ApivalidationMessage:'',
            alertMessage:'入力エラーがあります。',
            brandId: '',
            dailyCheckSettingLists:[
                {   dailyCheckPageId:null,
                    dailyCheckPageNo:0,
                    dailyCheckPageName:'',
                    manualFilePath:'',
                    informationFilePath:'',
                    displayFlg:null,
                    displayStr:'',
                    dailyCheckItemCount:null
                }
            ],
            checkPageSetting:{
                displayFlg: null,
                healthCheckPageSettings: {
                    manualFilePath:'',
                    informationFilePath:'',
                }
            },
            addFormFlg: true,
            preview: {
                button1: {
                    prefix: 'Index',
                    display: false,
                    name: '',
                },
                button2: {
                    prefix: 'Input',
                    display: false,
                    name: '',
                }
            },
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id: function () {
            return this.$store.getters['checkPage/id']
        },
        viewtype: function () {
            return this.$store.getters['checkPage/viewType']
        },
        bottunid: function () {
            return this.$store.getters['checkPage/buttonId']
        },
        menuid: function () {
            return this.$store.getters['checkPage/menuId']
        },
        buttonname: function () {
            return this.$store.getters['checkPage/buttonName']
        },
        buttonno: function () {
            return this.$store.getters['checkPage/buttonNo']
        },
    },
    created: async function(){
        await this.calc();
        this.setPreviewButton();
    },
    methods:{
        async calc(){

            var apiResponseFlg = true;

            // 企業ブランドIDの取得
            this.brandId = this.$store.getters['brand/id']
            // 当日日付取得
            var currentTime = this.getCurrentTime();
          var topButtonId = this.menuid
          // メニューページ設定概要取得API
          await this.$axios
              .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/' + topButtonId + '/page', {
                params: {
                  datetime: currentTime,
                  daily_check_button_id: this.id
                }})
              .then(response => (this.checkPageSetting = response.data))
              .catch((err) => {
                let error = {
                  button: {
                    path: {name: 'top', params:{brandPath: this.brandPath}}
                  }}
                apiResponseFlg = false;
                if (err.customError) {
                  error = Object.assign(error, err.customError)
                }
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }).finally(()=> this.isInitLoading = false);

          if(apiResponseFlg){
            this.dailySettingData();
          }

        },
        setPreviewButton() {
            let name = 'プレビュー';
            switch (this.viewtype) {
                case 'TOP':
                case 'day1':
                case 'day2':
                    this.preview.button1.display = true;
                    this.preview.button1.name = name;
                    break;
                case 'ImCheck':
                    break;
                default:
                    break;
            }
        },
        dailySettingData:function(){

            // デイリーデータの表示データを成形
            let itemList = [];
            for(var k = 0 ; k < 20 ; k++){
                var indexList = new Object();
                var settingFlg = false
                this.dailyCheckSettingLists = [];
                for( var i=0 ; i < this.checkPageSetting.dailyCheckPageSettings.length ; i++){
                    if(this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageNo == (k + 1)){
                        indexList['dailyCheckPageId']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageId;
                        indexList['dailyCheckPageNo']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageNo;
                        indexList['dailyCheckPageName']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckPageName;
                        indexList['manualFilePath']  = this.checkPageSetting.dailyCheckPageSettings[i].manualFilePath;
                        indexList['informationFilePath']  = this.checkPageSetting.dailyCheckPageSettings[i].informationFilePath;
                        indexList['displayFlg']  = this.checkPageSetting.dailyCheckPageSettings[i].displayFlg;
                        indexList['displayStr']  = this.checkPageSetting.dailyCheckPageSettings[i].displayStr;
                        indexList['dailyCheckItemCount']  = this.checkPageSetting.dailyCheckPageSettings[i].dailyCheckItemCount;
                        settingFlg = true;
                        break;
                    }
                }
                if(settingFlg == false){
                    indexList['dailyCheckPageId']  = null;
                    indexList['dailyCheckPageNo']  = k + 1;
                    indexList['dailyCheckPageName']  = '';
                    indexList['manualFilePath']  = '';
                    indexList['informationFilePath']  = '';
                    indexList['displayFlg']  = null;
                    indexList['displayStr']  = '';
                    indexList['dailyCheckItemCount']  = 0;
                }
                itemList.push(indexList);
            }
            this.dailyCheckSettingLists = itemList;
        },

        getCurrentTime() {
            // 当日日付をyyyymmddhhmmssで返却
            var now = new Date();
            var res = now.getFullYear() +
                      this.padZero(now.getMonth() + 1) +
                      this.padZero(now.getDate()) +
                      this.padZero(now.getHours()) +
                      this.padZero(now.getMinutes()) +
                      this.padZero(now.getSeconds());
            return res;
        },
        padZero(num) {
            //先頭ゼロ付加
            var result;
            if (num < 10) {
                result = "0" + num;
            } else {
                result = "" + num;
            }
            return result;
        },

        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        },
        jsonToFormData(data) {
            const formData = new FormData();

            this.buildFormData(formData, data);

            return formData;
        },
        setDailyCheckSetting(id,no) {
            var dailyCheckSetting = {
                id: id,
                no: no,
            }
            this.$store.dispatch('checkPage/setDailyCheckSetting', dailyCheckSetting);
        },

        clearError(){
            //メッセージ初期化
            this.alertMessage = "";
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>